
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.2 5.333L.667 2.667h14.666L14.8 5.333h-1.353L13.707 4H2.293l.276 1.333H1.2zm12.383-4L13.986 0H2l.459 1.333h11.124zM16 6.667l-1.333 8.666H1.333L0 6.667h16zm-5.333 2.666A.666.666 0 0010 8.667H6A.666.666 0 106 10h4a.666.666 0 00.667-.667z","fill":"#3F51B5"}})])
          )
        }
      }
    